<script>

  import localforage from 'localforage'

  export default {
    data () {
      return {}
    },
    computed: {
      sessions () {
        return this.$store.getters['sessions']
      },
      currentId () {
        return this.$store.getters['currentId']
      }
    },
    filters: {
      getPlatform (id) {
        switch (id) {
          case 1:
            return '通' //代练通
          case 4:
            return '妈' //代练妈妈
          case 16:
            return '内' //内群
          default:
            return '代' //暂未定义
        }
      },
    },
    mounted () {
    },
    methods: {
      selectSession (id) {
        let that = this
        let db = that.$store.getters.webDB
        this.$store.dispatch('selectSession', id)
        db.getItem(id).then(function (value) {
          value.msgNum = 0
          db.setItem(id, value)
        })
      }
    }
  }
</script>

<template>
  <div class="list">
    <ul>
      <li v-for="item in sessions" :class="{ active: item.id === currentId }" @click="selectSession(item.id)">
        <el-badge :value="item.msgNum" :max="99" class="item" :hidden="item.msgNum==0">
          <div class="avatar"><span class="avatar-content">{{item.platformId | getPlatform}}</span></div>
        </el-badge>
        <p class="name">{{item.user.name}}</p>
      </li>

    </ul>
  </div>
</template>

<style scoped lang="less">
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.1);
  }

  ::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.1);
  }

  ::-webkit-scrollbar {
    width: 10px;
  }
  .list {
    height: 85%;
    overflow-y: scroll;

    ul {
      list-style-type: none;
      padding-left: 0px;
      margin-bottom: 10px;
    }



    li {
      padding: 12px 15px;
      border-bottom: 1px solid #292C33;
      cursor: pointer;
      transition: background-color .1s;
      overflow: hidden;
      white-space: nowrap;
      width: 160px;
      text-overflow: ellipsis;

      &:hover {
        background-color: rgba(255, 255, 255, 0.03);
      }

      &.active {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }

    .avatar {
      background-color: rgb(89, 150, 251);
      color: rgb(248, 248, 248);
      width: 40px;
      height: 40px;
      border-radius: 2px;
      font-size: 18px;
      text-align: center;
      display: inline-block;
    }

    .avatar-content {
      margin-top: 20%;
      display: block;
    }

    .name {
      display: inline-block;
      margin: 0 0 0 15px;
      font-size: 12px;
    }
  }
</style>
